/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_USERNAME = 'boilerplate/Home/CHANGE_USERNAME';
// export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD'
export const LOADER_STATUS = 'boilerplate/Landing/LOADER_STATUS'
export const RESPONSE_MESSAGE = 'boilerplate/Landing/RESPONSE_MESSAGE'
export const INVOICE_DATA = 'boilderplate/Landing/INVOICE_DATA'
export const PROFILE_DATA = 'boilderplate/Landing/PROFILE_DATA'
export const UPDATE_MODULE = 'boilerplate/Landing/UPDATE_MODULE'
export const SET_RADIO_VAL = 'biolerplate/Landing/SET_RADIO_VAL'
export const ON_CALL_UPLOAD = 'biolerplate/Invoice_Details/ON_CALL_UPLOAD'